<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Status and activation</mat-card-title>
    <button *ngIf="editStatus"
            mat-icon-button
            routerLink="status"
            aria-label="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="statusValue">
        <div class="status-container">
          <ifb-account-status-icon-chip [status]="data.account?.status"></ifb-account-status-icon-chip>
          <button class="mat-icon-button-sm"
                  *ngIf="editInfo && data.account?.status === LoanStatus.Pending && data.account?.loanInfo.principalBalance === 0"
                  mat-icon-button
                  matTooltip="Delete account"
                  (click)="deleteAccount()"
                  aria-label="delete">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </ng-template>
      <ng-template horizontalListCustomTemplate="delinquentStatusValue">
        <div class="status-container">
          <ifb-account-status-icon-chip [status]="data.account?.delinquentStatus"></ifb-account-status-icon-chip>
        </div>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
